import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User } from "lucide-react";

interface TableNicknameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tableNumber: string;
  currentName: string | null;
  onSave: (name: string | null) => Promise<void>;
  isCommand?: boolean;
}

export function TableNicknameDialog({
  open,
  onOpenChange,
  tableNumber,
  currentName,
  onSave,
  isCommand = false,
}: TableNicknameDialogProps) {
  const [name, setName] = useState(currentName || "");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setName(currentName || "");
    }
  }, [open, currentName]);

  const handleSave = async () => {
    setIsSubmitting(true);
    try {
      await onSave(name.trim() || null);
      onOpenChange(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <User className="h-5 w-5" />
            Apelido {isCommand ? "da Comanda" : "da Mesa"} {tableNumber}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="tableName">Nome / Apelido</Label>
            <Input
              id="tableName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex: João, Aniversário, Reunião..."
              maxLength={50}
              autoFocus
            />
            <p className="text-xs text-muted-foreground">
              Deixe em branco para remover o apelido
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleSave} disabled={isSubmitting}>
            {isSubmitting ? "Salvando..." : "Salvar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
